import { AgendaMagasinComponent } from '@components/agenda-magasin';
import { AgendaMagasinTunnelComponent } from '@components/agenda-magasin-tunnel';
import { AvisGoogleComponent } from '@components/avis-google';
import { AvisGoogleDetailsComponent } from '@components/avis-google-details';
import { BandeauBeneficesComponent } from '@components/bandeau-benefices';
import { BoutonFiltreFaqComponent } from '@components/bouton-filtre-faq';
import { CarteOpportunitesComponent } from '@components/carte-opportunites';
import { CartesDynamiquesComponent } from '@components/cartes-dynamiques';
import { ConfirmationFormulaireComponent } from '@components/confirmation-formulaire';
import { ConfirmationRdvComponent } from '@components/confirmation-rdv';
import { ConfirmationRdvEspaceClientComponent } from '@components/confirmation-rdv-espace-client';
import { ContenuArticleComponent } from '@components/contenu-article';
import { ContenuCtaVideoComponent } from '@components/contenu-cta-video';
import { ContenuPosePushTutosNoticesComponent } from '@components/contenu-pose-push-tutos-notices';
import { ContenuPosePushVideoComponent } from '@components/contenu-pose-push-video';
import { ContenuPromoComponent } from '@components/contenu-promo';
import { ContenuTemoignageComponent } from '@components/contenu-temoignage';
import { DetailsFaqComponent } from '@components/details-faq';
import { EncartEditoComponent } from '@components/encart-edito';
import { EncartInfosMagasinComponent } from '@components/encart-infos-magasin';
import { EncartMiseEnAvantComponent } from '@components/encart-mise-en-avant';
import { EncartPackProduitsTitreTexteLogosComponent } from '@components/encart-pack-produits-titre-texte-logos';
import { EstimateurBudgetDetailPrixComponent } from '@components/estimateur-budget-detail-prix';
import { EstimateurBudgetSelectionComponent } from '@components/estimateur-budget-selection';
import { EstimateurEtapeComponent } from '@components/estimateur-etape';
import { FormulaireCatalogueComponent } from '@components/formulaire-catalogue';
import { FormulaireContactB2bComponent } from '@components/formulaire-contact-b2b';
import { FormulaireContactB2cComponent } from '@components/formulaire-contact-b2c';
import { FormulaireRdvComponent } from '@components/formulaire-rdv';
import { GalerieComponent } from '@components/galerie';
import { MenuBlogComponent } from '@components/header/menu-blog';
import { HeroComponent } from '@components/hero';
import { HeroModeleComponent } from '@components/hero-modele';
import { HeroSliderComponent } from '@components/hero-slider';
import { IframeComponent } from '@components/iframe';
import { ImageHeroComponent } from '@components/image-hero';
import { InstagramComponent } from '@components/instagram';
import { ListeAccordeonComponent } from '@components/liste-accordeon';
import { ListeCarteImageNomComponent } from '@components/liste-carte-image-nom';
import { ListeCarteImageTitreLienComponent } from '@components/liste-carte-image-titre-lien';
import { ListingArticlesBlogComponent } from '@components/listing-articles-blog';
import { ListingAutresFacadesComponent } from '@components/listing-autres-facades';
import { ListingCategoriesFacadesComponent } from '@components/listing-categories-facades';
import { ListingCoinRepasComponent } from '@components/listing-coin-repas';
import { ListingCorpsDeMeubleComponent } from '@components/listing-corps-de-meuble';
import { ListingFacadesComponent } from '@components/listing-facades';
import { ListingFaqComponent } from '@components/listing-faq';
import { ListingMagasinComponent } from '@components/listing-magasin';
import { ListingMeublesImageNomComponent } from '@components/listing-meubles-image-nom';
import { ListingMeublesImageNomDescriptionComponent } from '@components/listing-meubles-image-nom-description';
import { ListingModelesComponent } from '@components/listing-modeles';
import { ListingModelesPageFiltreComponent } from '@components/listing-modeles-page-filtre';
import { ListingPackProduitsComponent } from '@components/listing-pack-produits';
import { ListingPagesFiltreComponent } from '@components/listing-pages-filtre';
import { ListingPlansDeTravailComponent } from '@components/listing-plans-de-travail';
import { ListingPoigneesComponent } from '@components/listing-poignees';
import { ListingRealisationsComponent } from '@components/listing-realisations';
import { ListingTemoignagesComponent } from '@components/listing-temoignages';
import { ListingTutosComponent } from '@components/listing-tutos';
import { MadeInFranceComponent } from '@components/made-in-france';
import { MentionsBudgetDynamiquesComponent } from '@components/mentions-budget-dynamiques';
import { MessageErreurComponent } from '@components/message-erreur';
import { OngletsComponent } from '@components/onglets';
import { PromesseComponent } from '@components/promesse';
import { PushArticlesBlogB2bComponent } from '@components/push-articles-blog-b2b';
import { PushArticlesBlogB2cComponent } from '@components/push-articles-blog-b2c';
import { PushContenusComponent } from '@components/push-contenus';
import { PushEncartsVertsComponent } from '@components/push-encarts-verts';
import { PushFaqComponent } from '@components/push-faq';
import { PushLiensComponent } from '@components/push-liens';
import { PushRealisationsClientsComponent } from '@components/push-realisations-clients/push-realisations-clients.component';
import { PushTemoignagesComponent } from '@components/push-temoignages';
import { PushTutosComponent } from '@components/push-tutos/push-tutos.component';
import { RubriquesBlogComponent } from '@components/rubriques-blog';
import { SliderCartesImageNomComponent } from '@components/slider-cartes-image-nom';
import { SliderGalerieImagesComponent } from '@components/slider-galerie-images';
import { SliderImplantationsComponent } from '@components/slider-implantations';
import { SliderVideoComponent } from '@components/slider-video';
import { SpacerComponent } from '@components/spacer';
import { StickerTexteComponent } from '@components/sticker-texte';
import { StoreLocatorComponent } from '@components/store-locator';
import { TexteHtmlComponent } from '@components/texte-html';
import { TexteSeoComponent } from '@components/texte-seo';
import { TexteSeoVisuelBasComponent } from '@components/texte-seo-visuel-bas';
import { TitreBudgetComponent } from '@components/titre-budget';
import { TitreDescriptionComponent } from '@components/titre-description';
import { TitreDescriptionMenuVisuelComponent } from '@components/titre-description-menu-visuel';
import { TitreDescriptionVideoComponent } from '@components/titre-description-video';
import { TitreFiltresModelesComponent } from '@components/titre-filtres-modeles';
import { TitreTexteCtaImageComponent } from '@components/titre-texte-cta-image';
import { TitreTexteInfoComponent } from '@components/titre-texte-info';
import { TitreTexteMediaComponent } from '@components/titre-texte-media';
import { TriptyqueStickersComponent } from '@components/triptyque-stickers';
import { VideoYoutubeComponent } from '@components/video-youtube';
import { DynamicComponents } from '@shared/services/component-loader/models';

export const componentsToLoad: DynamicComponents[] = [
  {
    type: 'hero',
    component: HeroComponent,
  },
  {
    type: 'cartes-dynamiques',
    component: CartesDynamiquesComponent,
  },
  {
    type: 'promesse',
    component: PromesseComponent,
  },
  {
    type: 'avis-google',
    component: AvisGoogleComponent,
  },
  {
    type: 'texte-seo',
    component: TexteSeoComponent,
  },
  {
    type: 'texte-seo-visuel-bas',
    component: TexteSeoVisuelBasComponent,
  },
  {
    type: 'titre-description',
    component: TitreDescriptionComponent,
  },
  {
    type: 'titre-description-menu-visuel',
    component: TitreDescriptionMenuVisuelComponent,
  },
  {
    type: 'instagram',
    component: InstagramComponent,
  },
  {
    type: 'avis-google-details',
    component: AvisGoogleDetailsComponent,
  },
  {
    type: 'galerie',
    component: GalerieComponent,
  },
  {
    type: 'titre-filtres-modeles',
    component: TitreFiltresModelesComponent,
  },
  {
    type: 'listing-modeles',
    component: ListingModelesComponent,
  },
  {
    type: 'hero-modele',
    component: HeroModeleComponent,
  },
  {
    type: 'hero-slider',
    component: HeroSliderComponent,
  },
  {
    type: 'slider-video',
    component: SliderVideoComponent,
  },
  {
    type: 'slider-implantations',
    component: SliderImplantationsComponent,
  },
  {
    type: 'encart-infos-magasin',
    component: EncartInfosMagasinComponent,
  },
  {
    type: 'encart-mise-en-avant',
    component: EncartMiseEnAvantComponent,
  },
  {
    type: 'contenu-cta-video',
    component: ContenuCtaVideoComponent,
  },
  {
    type: 'push-faq',
    component: PushFaqComponent,
  },
  {
    type: 'bandeau-benefices',
    component: BandeauBeneficesComponent,
  },
  {
    type: 'store-locator',
    component: StoreLocatorComponent,
  },
  {
    type: 'agenda-magasin-tunnel',
    component: AgendaMagasinTunnelComponent,
  },
  {
    type: 'formulaire-rdv',
    component: FormulaireRdvComponent,
  },
  {
    type: 'confirmation-rdv',
    component: ConfirmationRdvComponent,
  },
  {
    type: 'confirmation-rdv-espace-client',
    component: ConfirmationRdvEspaceClientComponent,
  },
  {
    type: 'agenda-magasin',
    component: AgendaMagasinComponent,
  },
  {
    type: 'titre-texte-cta-image',
    component: TitreTexteCtaImageComponent,
  },
  {
    type: 'estimateur-etape',
    component: EstimateurEtapeComponent,
  },
  {
    type: 'slider-cartes-image-nom',
    component: SliderCartesImageNomComponent,
  },
  {
    type: 'estimateur-budget-detail-prix',
    component: EstimateurBudgetDetailPrixComponent,
  },
  {
    type: 'push-realisations-clients',
    component: PushRealisationsClientsComponent,
  },
  {
    type: 'encart-pack-produits-titre-texte-logos',
    component: EncartPackProduitsTitreTexteLogosComponent,
  },
  {
    type: 'estimateur-budget-selection',
    component: EstimateurBudgetSelectionComponent,
  },
  {
    type: 'listing-coin-repas',
    component: ListingCoinRepasComponent,
  },
  {
    type: 'made-in-france',
    component: MadeInFranceComponent,
  },
  {
    type: 'mentions-budget-dynamiques',
    component: MentionsBudgetDynamiquesComponent,
  },
  {
    type: 'onglets',
    component: OngletsComponent,
  },
  {
    type: 'contenu-pose-push-video',
    component: ContenuPosePushVideoComponent,
  },
  {
    type: 'contenu-pose-push-tutos-notices',
    component: ContenuPosePushTutosNoticesComponent,
  },
  {
    type: 'titre-budget',
    component: TitreBudgetComponent,
  },
  {
    type: 'video-youtube',
    component: VideoYoutubeComponent,
  },
  {
    type: 'listing-tutos',
    component: ListingTutosComponent,
  },
  {
    type: 'titre-texte-info',
    component: TitreTexteInfoComponent,
  },
  {
    type: 'listing-categories-facades',
    component: ListingCategoriesFacadesComponent,
  },
  {
    type: 'listing-pack-produits',
    component: ListingPackProduitsComponent,
  },
  {
    type: 'push-articles-blog-b2c',
    component: PushArticlesBlogB2cComponent,
  },
  {
    type: 'push-contenus',
    component: PushContenusComponent,
  },
  {
    type: 'listing-facades',
    component: ListingFacadesComponent,
  },
  {
    type: 'push-tutos',
    component: PushTutosComponent,
  },
  {
    type: 'liste-carte-image-nom',
    component: ListeCarteImageNomComponent,
  },
  {
    type: 'liste-carte-image-titre-lien',
    component: ListeCarteImageTitreLienComponent,
  },
  {
    type: 'listing-plans-de-travail',
    component: ListingPlansDeTravailComponent,
  },
  {
    type: 'listing-corps-de-meuble',
    component: ListingCorpsDeMeubleComponent,
  },
  {
    type: 'listing-poignees',
    component: ListingPoigneesComponent,
  },
  {
    type: 'listing-meubles-image-nom',
    component: ListingMeublesImageNomComponent,
  },
  {
    type: 'listing-meubles-image-nom-description',
    component: ListingMeublesImageNomDescriptionComponent,
  },
  {
    type: 'contenu-promo',
    component: ContenuPromoComponent,
  },
  {
    type: 'listing-autres-facades',
    component: ListingAutresFacadesComponent,
  },
  {
    type: 'contenu-article',
    component: ContenuArticleComponent,
  },
  {
    type: 'image-hero',
    component: ImageHeroComponent,
  },
  {
    type: 'menu-blog',
    component: MenuBlogComponent,
  },
  {
    type: 'details-faq',
    component: DetailsFaqComponent,
  },
  {
    type: 'liste-accordeon',
    component: ListeAccordeonComponent,
  },
  {
    type: 'contenu-temoignage',
    component: ContenuTemoignageComponent,
  },
  {
    type: 'formulaire-catalogue',
    component: FormulaireCatalogueComponent,
  },
  {
    type: 'push-temoignages',
    component: PushTemoignagesComponent,
  },
  {
    type: 'formulaire-contact-b2c',
    component: FormulaireContactB2cComponent,
  },
  {
    type: 'slider-galerie-images',
    component: SliderGalerieImagesComponent,
  },
  {
    type: 'titre-texte-media',
    component: TitreTexteMediaComponent,
  },
  {
    type: 'texte-html',
    component: TexteHtmlComponent,
  },
  {
    type: 'message-erreur',
    component: MessageErreurComponent,
  },
  {
    type: 'push-encarts-verts',
    component: PushEncartsVertsComponent,
  },
  {
    type: 'triptyque-stickers',
    component: TriptyqueStickersComponent,
  },
  {
    type: 'encart-edito',
    component: EncartEditoComponent,
  },
  {
    type: 'titre-description-video',
    component: TitreDescriptionVideoComponent,
  },
  {
    type: 'push-liens',
    component: PushLiensComponent,
  },
  {
    type: 'formulaire-contact-b2b',
    component: FormulaireContactB2bComponent,
  },
  {
    type: 'listing-articles-blog',
    component: ListingArticlesBlogComponent,
  },
  {
    type: 'carte-opportunites',
    component: CarteOpportunitesComponent,
  },
  {
    type: 'bouton-filtre-faq',
    component: BoutonFiltreFaqComponent,
  },
  {
    type: 'listing-faq',
    component: ListingFaqComponent,
  },
  {
    type: 'rubriques-blog',
    component: RubriquesBlogComponent,
  },
  {
    type: 'listing-temoignages',
    component: ListingTemoignagesComponent,
  },
  {
    type: 'listing-pages-filtre',
    component: ListingPagesFiltreComponent,
  },
  {
    type: 'sticker-texte',
    component: StickerTexteComponent,
  },
  {
    type: 'listing-magasin',
    component: ListingMagasinComponent,
  },
  {
    type: 'listing-modeles-page-filtre',
    component: ListingModelesPageFiltreComponent,
  },
  {
    type: 'push-articles-blog-b2b',
    component: PushArticlesBlogB2bComponent,
  },
  {
    type: 'listing-realisations',
    component: ListingRealisationsComponent,
  },
  {
    type: 'iframe',
    component: IframeComponent,
  },
  {
    type: 'spacer',
    component: SpacerComponent,
  },
  {
    type: 'confirmation-formulaire',
    component: ConfirmationFormulaireComponent,
  },
];
